"use client"

import { resolveStagedPreviewBackendUrl } from "@lib/util/staged-preview"
import styles from "./garanti-secure-payment.module.css"

const LOGO_FILE = "vetpets-garanti-bbva-secure-payment.png"

function logoUrl() {
  const backend = resolveStagedPreviewBackendUrl(
    process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL,
    typeof document !== "undefined" ? document.cookie : undefined,
    typeof window !== "undefined" ? window.location.origin : undefined
  )
  return backend + "/static/" + LOGO_FILE
}

export default function GarantiSecurePayment({
  compact = false,
  header = false,
}: {
  compact?: boolean
  header?: boolean
}) {
  const className = [
    styles.root,
    compact ? styles.compact : "",
    header ? styles.header : "",
  ].filter(Boolean).join(" ")

  return (
    <span className={className} aria-label="Garanti BBVA altyapısıyla güvenli ödeme">
      <img className={styles.logo} src={logoUrl()} alt="Garanti BBVA" loading="lazy" />
      <span className={styles.copy}>{header ? "Güvenli ödeme" : "altyapısıyla güvenli ödeme"}</span>
    </span>
  )
}
